import { TFunction } from 'i18next'
import Overview from './Overview'
import Uses from './Uses'
import { Promo } from '../../types'

interface TabsProps {
    t: TFunction
    promo?: Promo
    promoId: number
    refetch: () => void
}

export const tabs = ({ t, promo, promoId, refetch }: TabsProps) => [
    {
        label: t('overview'),
        value: 'overview',
        component: <Overview promo={promo} refetch={refetch} />,
    },
    {
        label: t('usage_history'),
        value: 'uses',
        component: <Uses promoId={promoId} />,
    },
]
